var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmotionsAngry = function SvgEmotionsAngry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "url(#emotions-angry_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.468 5.144a.833.833 0 0 0-.936 1.379l.946.643a1.667 1.667 0 1 0 2.83.877.833.833 0 0 0-.238-1.131L5.468 5.144Zm1.195 9.64a.75.75 0 0 1-.277-1.024 4.166 4.166 0 0 1 7.227-.002.75.75 0 0 1-1.3.747 2.666 2.666 0 0 0-4.626.002.75.75 0 0 1-1.024.277Zm9.127-9.42a.833.833 0 0 0-1.157-.22l-2.601 1.768a.834.834 0 0 0-.31.99A1.668 1.668 0 0 0 13.334 10a1.667 1.667 0 0 0 1.229-2.793l1.008-.684a.833.833 0 0 0 .22-1.158Z",
    fill: "#000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "emotions-angry_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(90 2.708 7.292) scale(15.4167)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#F26325"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F24A25"
  })))));
};
export default SvgEmotionsAngry;